import { cn } from "logic/utils";

import type { Loan } from "./data/types";
import { LoanRow, TABLE_VISIBLE } from "./LoanRow";

/** Desktop column headers. Widths mirror `LoanRow`'s desktop layout: `Collateral`
 *  is the fixed 225px column, the middle five flex, and the trailing 56px cell
 *  is the empty header above the chevron. Figma insets this first label by 8px
 *  while the row's own text sits at 16px. */
const COLUMNS = ["Collateral", "Status", "Principal", "APR", "Next Payment", "Payment Amount"];

type Props = {
  loans: Loan[];
};

export function ActiveLoansSection(props: Props) {
  const { loans } = props;

  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-title-lg-400 text-surface-on-surface">Active Loans</h2>

      <div className="flex flex-col gap-1">
        {/* Header row belongs to the table layout, so it shares its breakpoint. */}
        <div className={cn(TABLE_VISIBLE, "items-start")}>
          {COLUMNS.map((column, index) => (
            <div
              key={column}
              className={index === 0 ? "w-[225px] shrink-0 px-2 py-1" : "min-w-0 flex-1 px-4 py-1"}
            >
              <p className="text-body-sm-400 whitespace-nowrap text-surface-on-surface-subtle">{column}</p>
            </div>
          ))}
          <div className="w-14 shrink-0" />
        </div>

        {loans.length ? (
          <div className="flex flex-col gap-1.5">
            {loans.map((loan) => (
              <LoanRow key={loan.loanTermsHash} loan={loan} />
            ))}
          </div>
        ) : (
          /* Message sits where the rows would, under the headings, so the page
             keeps its shape whether or not there are loans — the old table's
             pattern. No frame covers the empty state. */
          <p className="text-body-lg-400 py-8 text-center text-surface-on-surface-variant">No active loans</p>
        )}
      </div>
    </section>
  );
}
